export enum SIDEBAR_SIDE {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum SIDEBAR_VARIANT {
  SIDEBAR = 'sidebar',
  FLOATING = 'floating',
  INSET = 'inset',
}

export enum SIDEBAR_COLLAPSIBLE {
  OFFCANVAS = 'offcanvas',
  ICON = 'icon',
  NONE = 'none',
}

export enum SIDEBAR_USER_PREFERENCE {
  EXPANDED = 'expanded',
  COLLAPSED = 'collapsed',
}

export enum SIDEBAR_STATE {
  EXPANDED = 'expanded',
  COLLAPSED = 'collapsed',
}

export enum SIDEBAR_MENU_SUB_BUTTON_SIZE {
  SM = 'sm',
  MD = 'md',
}
